module.exports = __webpack_public_path__ + "src/assets/textures/env/tractor/tractor_4k_bake.png";